import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUser, IUserFilter, IUsersPagination, IUsersState, IUsersRemoveFailureActionPayload, IUserSaveFailure } from './types'


const initialState: IUsersState = {
  data: [],
  pagination: {
    count: 0,
    countFiltered: 0,
  },
  isLoading: false
}

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    usersListRequest: (state, action?: PayloadAction<IUserFilter | undefined>) => {
      state.isLoading = true;
      state.error = undefined;
    },
    usersListSuccess: (state, action: PayloadAction<IUser[]>) => {
      state.isLoading = false;
      state.data = action.payload.sort((a, b) => a.name.localeCompare(b.name));
      state.error = undefined;
    },
    usersListFailure: (state, action: PayloadAction<ISystemErrors>) => {
      state.isLoading = false
      state.error = action.payload;
    },
    usersSetPagination: (state, action: PayloadAction<IUsersPagination>) => {
      state.pagination = action.payload
    },
    startEditingUsers: (state, action: PayloadAction<IUser>) => {
      state.draftUser = action.payload;
    },
    stopEditingUsers: (state) => {
      state.draftUser = undefined;
    },
    usersDraftUpdate: (state, action: PayloadAction<IUser>) => {
      state.draftUser = action.payload;
    },
    usersSaveRequest: (state, action: PayloadAction<IUser>) => {
      if (state.draftUser) {
        state.draftUser.isSaving = true;
        state.draftUser.error = undefined;
      }
      state.error = undefined;
    },
    usersSaveSuccess: (state, action: PayloadAction<IUser>) => {
      const oldUser = state.data.find(users => users.id === action.payload.id)

      if (!oldUser) {
        state.data.push({
          ...action.payload,
          error: undefined
        })
        state.data = state.data.sort((a, b) => a.name.localeCompare(b.name));
      }
      else {
        state.data = state.data.map(users => {
          if (users.id !== action.payload.id) return users;

          return {
            ...users,
            ...action.payload,
            isSaving: false,
            error: undefined
          }

        }).sort((a, b) => a.name.localeCompare(b.name));
      }
      state.draftUser = undefined;
      state.error = undefined;
    },
    usersSaveFailure: (state, action: PayloadAction<IUserSaveFailure>) => {
      if (state.draftUser) {
        state.draftUser.isSaving = false
        state.draftUser.error = action.payload.error
      }
    },
    usersRemoveRequest: (state, action: PayloadAction<string>) => {
      state.data = state.data.map(users => {
        if (users.id !== action.payload) return users;

        return {
          ...users,
          isDeleting: true
        }
      })
    },
    usersRemoveSuccess: (state, action: PayloadAction<string>) => {
      state.data = state.data.filter(users => users.id !== action.payload)
    },
    usersRemoveFailure: (state, action: PayloadAction<IUsersRemoveFailureActionPayload>) => {
      state.data = state.data.map(users => {
        if (users.id !== action.payload.userId) return users;

        return {
          ...users,
          isDeleting: false,
          error: action.payload.error
        }
      })
    },
  }
})

// Action creators are generated for each case reducer function
export const {
  usersListRequest,
  usersListSuccess,
  usersListFailure,
  usersSetPagination,
  startEditingUsers,
  stopEditingUsers,
  usersDraftUpdate,
  usersSaveRequest,
  usersSaveSuccess,
  usersSaveFailure,
  usersRemoveRequest,
  usersRemoveSuccess,
  usersRemoveFailure,

} = usersSlice.actions

export default usersSlice.reducer